module.exports = __webpack_public_path__ + "img/mobile-menu-rewards.bc6cf64f.webp";